import React, {ButtonHTMLAttributes, DetailedHTMLProps, FC} from 'react';

interface ButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    underline?: boolean;
}

const Button: FC<ButtonProps> = ({underline = true, className, children, ...restProps}) => (

    <button
        className={`bg-sk-primary-blue uppercase
         tracking-wider group flex
         justify-center py-2.5 m-2
         px-6 border border-transparent text-sm font-medium
         rounded-3xl text-white hover:bg-sk-primary-blue-200
         hover:opacity-70 focus:outline-none focus:ring-2
         focus:ring-offset-2 ${className}`} {...restProps}>
        {children}
    </button>
);
export default Button;
